export function secureRandomNumber(): number {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0];
}

export function secureRandomFloat(): number {
  const array = new Uint32Array(1);
  window.crypto.getRandomValues(array);
  return array[0] / 0xffffffff;
}

export function secureRandomString(length = 16): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charsLength = chars.length;
  let result = '';

  while (result.length < length) {
    const array = new Uint8Array(length - result.length);
    window.crypto.getRandomValues(array);

    for (const byte of array) {
      if (byte < Math.floor(256 / charsLength) * charsLength) {
        result += chars[byte % charsLength];
      }
    }
  }

  return result;
}
